import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(checkboxAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var baseStyle = definePartsStyle({
    control: {
        border: '1px solid',
        borderColor: 'neutrals.700',
        color: 'neutrals.800 !important',
        _checked: {
            borderColor: 'neutrals.800',
            bg: 'neutrals.800',
            color: "white",
            px: '2.5px',
            py: 1,
            _hover: {
                borderColor: 'neutrals.800',
                bg: 'neutrals.800',
            }
        },
        _disabled: {
            borderColor: 'neutrals.400 !important',
            borderRadius: 'sm',
            bg: 'neutrals.white',
            color: 'neutrals.500 !important',
            _checked: {
                bg: 'neutrals.500',
            }
        },
        _invalid: {
            border: '2px solid',
            borderColor: 'error.500 !important',
            borderRadius: 'sm'
        }
    },
    icon: {
        width: '12px',
        height: '8px',
        color: "neutrals.white",
        _hover: {
            color: "neutrals.white",
        }
    },
});
var checkboxTheme = defineMultiStyleConfig({ baseStyle: baseStyle });

export { checkboxTheme };
//# sourceMappingURL=checkbox.js.map
